import { useGetOrganizationByIdQuery } from '@/apis/hooks/organizations';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAdminAgentActions } from './use-admin-agent';

const ORGANIZATION_ROUTE_RE = /^\/organization\/([^/]+)/;

/** Keeps Kin scope aligned with `/organization/:orgId` without opening the drawer. */
export function AdminAgentRouteScopeSync() {
  const location = useLocation();
  const { openOrganization, openPortfolio } = useAdminAgentActions();

  // Parse from pathname: AppLayout sits on `/`, so useParams() never sees child `:orgId`.
  const organizationRouteMatch = ORGANIZATION_ROUTE_RE.exec(location.pathname);
  const scopedOrgId = organizationRouteMatch?.[1];

  const { data: organization } = useGetOrganizationByIdQuery(scopedOrgId || '', Boolean(scopedOrgId));

  useEffect(() => {
    if (scopedOrgId) {
      openOrganization(scopedOrgId, organization?.name ?? scopedOrgId, { open: false });
      return;
    }
    openPortfolio({ open: false });
  }, [scopedOrgId, organization?.name, openOrganization, openPortfolio]);

  return null;
}
